import { Checkbox, Collapse, Radio } from 'antd';
import { TemplateConfig } from '../../../Templar/RenderPdfPrescription';
import { AntTooltip } from '../../../components/common/AntTooltip';
const { Panel } = Collapse;

const MedicalHistory: React.FC<{
    rxConfig: TemplateConfig | undefined;
    saveRxConfigInState: (rxObj: TemplateConfig) => void;
    sectionName?: string;
}> = ({ rxConfig, saveRxConfigInState, sectionName }) => {
    return (
        <Collapse
            expandIcon={() => (
                <div className="rounded-4 min-w-26 h-26 flex items-center justify-center bg-darwin-accent-medical-history-orange-900">
                    <div className="w-full h-full flex items-center justify-center">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            viewBox="0 0 11 13"
                            className="w-11 h-12 fill-white "
                        >
                            <path d="M10.75 8.375V1.625C10.75 1.01562 10.2344 0.5 9.625 0.5H2.5C1.23438 0.5 0.25 1.50781 0.25 2.75V10.25C0.25 11.5156 1.23438 12.5 2.5 12.5H10C10.3984 12.5 10.75 12.1719 10.75 11.7734C10.75 11.5156 10.5859 11.2812 10.375 11.1406V9.24219C10.5859 9.00781 10.75 8.72656 10.75 8.375ZM3.25 4.39062C3.25 4.20312 3.41406 4.01562 3.625 4.01562H4.86719V2.75C4.86719 2.5625 5.03125 2.375 5.24219 2.375H6.46094C6.64844 2.375 6.83594 2.5625 6.83594 2.75V4.01562H8.125C8.3125 4.01562 8.5 4.20312 8.5 4.39062V5.60938C8.5 5.82031 8.3125 5.98438 8.125 5.98438H6.85938V7.25C6.85938 7.46094 6.67188 7.625 6.48438 7.625H5.26562C5.05469 7.625 4.89062 7.46094 4.89062 7.25V5.98438H3.625C3.41406 5.98438 3.25 5.82031 3.25 5.60938V4.39062ZM9.25 11H2.5C2.07812 11 1.75 10.6719 1.75 10.25C1.75 9.85156 2.07812 9.5 2.5 9.5H9.25V11Z"></path>
                        </svg>
                    </div>
                </div>
            )}
        >
            <Panel
                header={
                    <div className="font-700">{sectionName || 'Medical & Vaccination History'}</div>
                }
                key="1"
            >
                <p className="mr-16 space-y-2">
                    <div className="cursor-pointer flex flex-1 items-center justify-between">
                        <span>Status Display</span>
                        <Radio.Group
                            onChange={(e) => {
                                saveRxConfigInState({
                                    medical_history_status_display: e.target.value,
                                });
                            }}
                            value={rxConfig?.medical_history_status_display ?? 'clinical'}
                        >
                            <Radio value={'clinical'}>Clinical</Radio>
                            <Radio value={'reported'}>Reported</Radio>
                        </Radio.Group>
                    </div>
                    <div className="cursor-pointer">
                        <p
                            className="cursor-pointer flex flex-1 items-center justify-between"
                            onClick={() => {
                                saveRxConfigInState({
                                    medical_history_name_in_unbold: !rxConfig?.medical_history_name_in_unbold,
                                });
                            }}
                        >
                            <span>Make the medical history name bold</span>
                            <Checkbox
                                checked={!rxConfig?.medical_history_name_in_unbold}
                            ></Checkbox>
                        </p>
                    </div>
                    <div className="cursor-pointer">
                        <p
                            className="cursor-pointer flex flex-1 items-center justify-between"
                            onClick={() => {
                                saveRxConfigInState({
                                    bullets_config: {
                                        ...rxConfig?.bullets_config,
                                        ['medicalHistory']: !rxConfig?.bullets_config?.[
                                            'medicalHistory'
                                        ],
                                    },
                                });
                            }}
                        >
                            <span>Use bullet points</span>
                            <Checkbox
                                checked={rxConfig?.bullets_config?.['medicalHistory']}
                            ></Checkbox>
                        </p>
                    </div>
                    <div className="border-b border-darwin-neutral-200 mx-8"></div>
                    <div>All Sections</div>
                    <div className="pl-8">
                        <div className="flex items-center justify-between">
                            <div>Heading</div>{' '}
                            <div className="flex space-x-12">
                                <input
                                    type="color"
                                    id="head"
                                    name="head"
                                    value={rxConfig?.pmh_heading_color || '#2188FF'}
                                    onChange={(e) => {
                                        saveRxConfigInState({
                                            pmh_heading_color: e.target.value,
                                        });
                                    }}
                                    className="circular-color-input"
                                />

                                <AntTooltip content="Reset">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                        onClick={() => {
                                            saveRxConfigInState({
                                                pmh_heading_color: '',
                                            });
                                        }}
                                    >
                                        <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                    </svg>
                                </AntTooltip>
                            </div>
                        </div>
                        <div className="flex items-center justify-between">
                            <div>Key Elements</div>{' '}
                            <div className="flex space-x-12">
                                <input
                                    type="color"
                                    id="head"
                                    name="head"
                                    value={rxConfig?.pmh_name_color || '#000000'}
                                    onChange={(e) => {
                                        saveRxConfigInState({
                                            pmh_name_color: e.target.value,
                                        });
                                    }}
                                    className="circular-color-input"
                                />

                                <AntTooltip content="Reset">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                        onClick={() => {
                                            saveRxConfigInState({
                                                pmh_name_color: '',
                                            });
                                        }}
                                    >
                                        <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                    </svg>
                                </AntTooltip>
                            </div>
                        </div>
                        <div className="flex items-center justify-between">
                            <div>Properties</div>{' '}
                            <div className="flex space-x-12">
                                <input
                                    type="color"
                                    id="head"
                                    name="head"
                                    value={rxConfig?.pmh_properties_color || '#000000'}
                                    onChange={(e) => {
                                        saveRxConfigInState({
                                            pmh_properties_color: e.target.value,
                                        });
                                    }}
                                    className="circular-color-input"
                                />

                                <AntTooltip content="Reset">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                        onClick={() => {
                                            saveRxConfigInState({
                                                pmh_properties_color: '',
                                            });
                                        }}
                                    >
                                        <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                    </svg>
                                </AntTooltip>
                            </div>
                        </div>{' '}
                    </div>

                    <Collapse
                        ghost
                        expandIcon={({ isActive }) => (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                                className="w-10 h-10 fill-darwin-neutral-700"
                                style={{
                                    rotate: isActive ? '180deg' : '90deg',
                                    transitionDuration: '0.2s',
                                }}
                            >
                                <path d="M290.5 51.8C283.3 39.5 270.2 32 256 32s-27.3 7.5-34.5 19.8l-216 368c-7.3 12.4-7.3 27.7-.2 40.1S25.7 480 40 480H472c14.3 0 27.6-7.7 34.7-20.1s7-27.8-.2-40.1l-216-368z" />
                            </svg>
                        )}
                    >
                        <Panel header="Individual Section Color" key={1} className="pmh-collapse">
                            <div className="space-y-4">
                                <div>Patient Medical History</div>
                                <div className="pl-8">
                                    <div className="flex items-center justify-between">
                                        <div>Heading</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.patient_medical_history_heading_color ||
                                                    rxConfig?.pmh_heading_color ||
                                                    '#2188FF'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        patient_medical_history_heading_color:
                                                            e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            patient_medical_history_heading_color:
                                                                '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <div>Key Elements</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.patient_medical_history_name_color ||
                                                    rxConfig?.pmh_name_color ||
                                                    '#000000'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        patient_medical_history_name_color:
                                                            e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            patient_medical_history_name_color: '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <div>Properties</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.patient_medical_history_properties_color ||
                                                    rxConfig?.pmh_properties_color ||
                                                    '#000000'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        patient_medical_history_properties_color:
                                                            e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            patient_medical_history_properties_color:
                                                                '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                </div>
                                <div className="border-b border-darwin-neutral-200 mx-8"></div>
                                <div>Family History</div>
                                <div className="pl-8">
                                    <div className="flex items-center justify-between">
                                        <div>Heading</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.family_history_heading_color ||
                                                    rxConfig?.pmh_heading_color ||
                                                    '#2188FF'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        family_history_heading_color:
                                                            e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            family_history_heading_color: '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <div>Key Elements</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.family_history_name_color ||
                                                    rxConfig?.pmh_name_color ||
                                                    '#000000'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        family_history_name_color: e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            family_history_name_color: '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <div>Properties</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.family_history_properties_color ||
                                                    rxConfig?.pmh_properties_color ||
                                                    '#000000'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        family_history_properties_color:
                                                            e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            family_history_properties_color: '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                </div>
                                <div className="border-b border-darwin-neutral-200 mx-8"></div>
                                <div>Lifestyle Habits</div>
                                <div className="pl-8">
                                    <div className="flex items-center justify-between">
                                        <div>Heading</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.lifestyle_habits_heading_color ||
                                                    rxConfig?.pmh_heading_color ||
                                                    '#2188FF'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        lifestyle_habits_heading_color:
                                                            e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            lifestyle_habits_heading_color: '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <div>Key Elements</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.lifestyle_habits_name_color ||
                                                    rxConfig?.pmh_name_color ||
                                                    '#000000'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        lifestyle_habits_name_color: e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            lifestyle_habits_name_color: '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <div>Properties</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.lifestyle_habits_properties_color ||
                                                    rxConfig?.pmh_properties_color ||
                                                    '#000000'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        lifestyle_habits_properties_color:
                                                            e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            lifestyle_habits_properties_color: '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                </div>
                                <div className="border-b border-darwin-neutral-200 mx-8"></div>
                                <div>Travel History</div>
                                <div className="pl-8">
                                    <div className="flex items-center justify-between">
                                        <div>Heading</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.travel_history_heading_color ||
                                                    rxConfig?.pmh_heading_color ||
                                                    '#2188FF'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        travel_history_heading_color:
                                                            e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            travel_history_heading_color: '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <div>Key Elements</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.travel_history_name_color ||
                                                    rxConfig?.pmh_name_color ||
                                                    '#000000'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        travel_history_name_color: e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            travel_history_name_color: '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <div>Properties</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.travel_history_properties_color ||
                                                    rxConfig?.pmh_properties_color ||
                                                    '#000000'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        travel_history_properties_color:
                                                            e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            travel_history_properties_color: '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                </div>
                                <div className="border-b border-darwin-neutral-200 mx-8"></div>
                                <div>Current Medications</div>
                                <div className="pl-8">
                                    <div className="flex items-center justify-between">
                                        <div>Heading</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.current_medications_heading_color ||
                                                    rxConfig?.pmh_heading_color ||
                                                    '#2188FF'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        current_medications_heading_color:
                                                            e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            current_medications_heading_color: '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <div>Key Elements</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.current_medications_name_color ||
                                                    rxConfig?.pmh_name_color ||
                                                    '#000000'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        current_medications_name_color:
                                                            e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            current_medications_name_color: '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <div>Properties</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.current_medications_properties_color ||
                                                    rxConfig?.pmh_properties_color ||
                                                    '#000000'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        current_medications_properties_color:
                                                            e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            current_medications_properties_color:
                                                                '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                </div>
                                <div className="border-b border-darwin-neutral-200 mx-8"></div>
                                <div>Drug Allergies</div>
                                <div className="pl-8">
                                    <div className="flex items-center justify-between">
                                        <div>Heading</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.drug_allergies_heading_color ||
                                                    rxConfig?.pmh_heading_color ||
                                                    '#2188FF'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        drug_allergies_heading_color:
                                                            e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            drug_allergies_heading_color: '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <div>Key Elements</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.drug_allergies_name_color ||
                                                    rxConfig?.pmh_name_color ||
                                                    '#000000'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        drug_allergies_name_color: e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            drug_allergies_name_color: '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <div>Properties</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.drug_allergies_properties_color ||
                                                    rxConfig?.pmh_properties_color ||
                                                    '#000000'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        drug_allergies_properties_color:
                                                            e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            drug_allergies_properties_color: '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                </div>
                                <div className="border-b border-darwin-neutral-200 mx-8"></div>
                                <div>Other Allergies</div>
                                <div className="pl-8">
                                    <div className="flex items-center justify-between">
                                        <div>Heading</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.other_allergies_heading_color ||
                                                    rxConfig?.pmh_heading_color ||
                                                    '#2188FF'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        other_allergies_heading_color:
                                                            e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            other_allergies_heading_color: '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <div>Key Elements</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.other_allergies_name_color ||
                                                    rxConfig?.pmh_name_color ||
                                                    '#000000'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        other_allergies_name_color: e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            other_allergies_name_color: '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <div>Properties</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.other_allergies_properties_color ||
                                                    rxConfig?.pmh_properties_color ||
                                                    '#000000'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        other_allergies_properties_color:
                                                            e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            other_allergies_properties_color: '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                </div>
                                <div className="border-b border-darwin-neutral-200 mx-8"></div>
                                <div>Past Procedures</div>
                                <div className="pl-8">
                                    <div className="flex items-center justify-between">
                                        <div>Heading</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.past_procedure_heading_color ||
                                                    rxConfig?.pmh_heading_color ||
                                                    '#2188FF'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        past_procedure_heading_color:
                                                            e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            past_procedure_heading_color: '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <div>Key Elements</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.past_procedure_name_color ||
                                                    rxConfig?.pmh_name_color ||
                                                    '#000000'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        past_procedure_name_color: e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            past_procedure_name_color: '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <div>Properties</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.past_procedure_properties_color ||
                                                    rxConfig?.pmh_properties_color ||
                                                    '#000000'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        past_procedure_properties_color:
                                                            e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            past_procedure_properties_color: '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                </div>
                                <div className="border-b border-darwin-neutral-200 mx-8"></div>
                                <div>Other Medical History</div>
                                <div className="pl-8">
                                    <div className="flex items-center justify-between">
                                        <div>Heading</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.other_medical_history_heading_color ||
                                                    rxConfig?.pmh_heading_color ||
                                                    '#2188FF'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        other_medical_history_heading_color:
                                                            e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            other_medical_history_heading_color: '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <div>Key Elements</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.other_medical_history_name_color ||
                                                    rxConfig?.pmh_name_color ||
                                                    '#000000'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        other_medical_history_name_color:
                                                            e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            other_medical_history_name_color: '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <div>Properties</div>{' '}
                                        <div className="flex space-x-12">
                                            <input
                                                type="color"
                                                id="head"
                                                name="head"
                                                value={
                                                    rxConfig?.other_medical_history_properties_color ||
                                                    rxConfig?.pmh_properties_color ||
                                                    '#000000'
                                                }
                                                onChange={(e) => {
                                                    saveRxConfigInState({
                                                        other_medical_history_properties_color:
                                                            e.target.value,
                                                    });
                                                }}
                                                className="circular-color-input"
                                            />

                                            <AntTooltip content="Reset">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                                    onClick={() => {
                                                        saveRxConfigInState({
                                                            other_medical_history_properties_color:
                                                                '',
                                                        });
                                                    }}
                                                >
                                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                                </svg>
                                            </AntTooltip>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                    </Collapse>
                </p>
                <style>
                    {`
                       .pmh-collapse .ant-collapse-header {
                           padding-left: 0px !important;
                           padding-right: 0px !important;
                           padding-bottom: 0px !important;
                       }
                       
                       .pmh-collapse .ant-collapse-content-box {
                           padding-left: 0px !important;
                           padding-right: 0px !important;
                           paddint-top: 0px !important;
                       }

                       .pmh-collapse .ant-collapse-header {
                          display: flex !important;
                          align-items: center !important;
                          justify-content: between !important;
                       }
                    `}
                </style>
            </Panel>
        </Collapse>
    );
};

export default MedicalHistory;
